export default __webpack_public_path__ + "static/media/twitter.dc23c084.svg";